// report.definition.js

export const FormatEnum = {'CURRENCY': 'CURRENCY', 'DATE': 'DATE'}
Object.freeze(FormatEnum)

export const ChartTypeEnum = {'PIE': 'PIE', 'BAR_AND_LINE': 'BAR_AND_LINE'}
Object.freeze(ChartTypeEnum)

const orderDetails = {
  title: 'Orders',
  api: 'get_order_details',
  chart: ChartTypeEnum.BAR_AND_LINE,
  chartLabelKeys: ['date'],
  chartValuePrefix: ['successful_', 'open_', 'failed_'],
  chartValueLabel: ['Shipped, Received and Payment Confirmed', 'Open', 'Abandoned'],
  filterPreselect: 'total',
  filterTabs: ['day', 'month', 'year'],
  table: [
    {
      key: 'date',
      label: 'Date'
    },
    {
      key: 'number_of_orders',
      label: 'Orders',
      filterable: true
    },
    {
      key: 'average_total',
      label: 'Average Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    },
    {
      key: 'products_count',
      label: 'Products',
      filterable: true
    },
    {
      key: 'total',
      label: 'Total',
      format: FormatEnum.CURRENCY,
      filterable: true,
      chartAverage: true
    }
  ]
}

const bestseller = {
  title: 'Bestseller',
  api: 'get_best_seller',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['sku', 'name'],
  table: [
    {
      key: 'sku',
      label: 'SKU'
    },
    {
      key: 'name',
      label: 'Name'
    },
    {
      key: 'quantity',
      label: 'Amount',
      filterable: true
    },
    {
      key: 'total',
      label: 'Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    }
  ]
}

const gender = {
  title: 'Gender',
  api: 'get_gender_orders',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['gender'],
  table: [
    {
      key: 'gender',
      label: 'Type'
    },
    {
      key: 'number_of_orders',
      label: 'Orders',
      filterable: true
    },
    {
      key: 'average_total',
      label: 'Average Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    },
    {
      key: 'number_of_products',
      label: 'Products',
      filterable: true
    },
    {
      key: 'total',
      label: 'Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    }
  ]
}

const abandoned = {
  title: 'Abandoned carts',
  api: 'get_abandoned_vs_completed',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['type'],
  table: [
    {
      key: 'type',
      label: 'Type'
    },
    {
      key: 'orders_number',
      label: 'Orders',
      filterable: true
    },
    {
      key: 'average_total',
      label: 'Average Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    },
    {
      key: 'products_count',
      label: 'Products',
      filterable: true
    },
    {
      key: 'total',
      label: 'Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    }
  ]
}

const returningVisitors = {
  title: 'New x returning customers',
  api: 'get_new_customers_orders',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['type'],
  table: [
    {
      key: 'type',
      label: 'Type'
    },
    {
      key: 'orders',
      label: 'Orders',
      filterable: true
    }
  ]
}

const boletoConversion = {
  title: 'Created x Paid invoices',
  api: 'get_aborted_vs_paid_orders',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['type'],
  table: [
    {
      key: 'type',
      label: 'Type'
    },
    {
      key: 'orders_number',
      label: 'Orders',
      filterable: true
    },
    {
      key: 'average_total',
      label: 'Average Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    },
    {
      key: 'products_count',
      label: 'Products',
      filterable: true
    },
    {
      key: 'total',
      label: 'Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    }
  ]
}

const paymentMethods = {
  title: 'Payment methods',
  api: 'get_payment_methods',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['payment_type'],
  table: [
    {
      key: 'payment_type',
      label: 'Type'
    },
    {
      key: 'orders_number',
      label: 'Orders',
      filterable: true
    },
    {
      key: 'average_total',
      label: 'Average Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    },
    {
      key: 'number_of_products',
      label: 'Products',
      filterable: true
    },
    {
      key: 'total',
      label: 'Total',
      format: FormatEnum.CURRENCY,
      filterable: true
    }
  ]
}

const reportDefinition = {
  'order_details': orderDetails,
  'best_seller': bestseller,
  'abandoned': abandoned,
  'returning_visitors': returningVisitors,
  'gender': gender,
  'boleto_conversion': boletoConversion,
  'payment_methods': paymentMethods
}

export default reportDefinition



// WEBPACK FOOTER //
// ./src/libs/report.definition.js